import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const slots = [5, 10, 15, 30, 45, 60, 90, 120];
const useTimeSlots = () => {
  const {
    t
  } = useTranslation();
  const [timeSlots, setTimeSlots] = useState();
  const min = t('GENERAL.minutes');
  if (!timeSlots) {
    const value = slots.map(x => ({
      label: "".concat(x, " ").concat(min),
      value: x
    }));
    setTimeSlots(value);
  }
  return timeSlots;
};
export { useTimeSlots };